import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { type IntlShape, useIntl } from 'react-intl';

import { getVehicleDisplayName, type Vehicle } from '#domain/Vehicle.ts';
import { getVehicleWarningState, type VehicleWarningState } from '#domain/VehicleWarning.ts';

type VehiclePlateProps = {
    vehicle: Vehicle | undefined;
};

export const getVehicleWarningMessage = (warningState: VehicleWarningState | undefined, intl: IntlShape) => {
    switch (warningState) {
        case 'missing-license':
            return intl.formatMessage({
                id: 'intl-msg:ordercom-cloud-frontend.vehicle.warning.missing-license.tooltip',
            });
        case 'missing-pocket-driver-data-source':
            return intl.formatMessage({
                id: 'intl-msg:ordercom-cloud-frontend.vehicle.warning.missing-pocket-driver-data-source.tooltip',
            });
        default:
            return undefined;
    }
};

export const VehicleWarningIcon = ({ warningState }: { warningState: VehicleWarningState | undefined }) => {
    const intl = useIntl();
    const warningMessage = getVehicleWarningMessage(warningState, intl);

    if (!warningMessage) {
        return null;
    }

    return (
        <SimpleTooltip content={warningMessage}>
            <span
                className='rioglyph rioglyph-warning-sign text-color-warning margin-left-5 display-inline-block'
                style={{ verticalAlign: 'top', paddingTop: 2 }}
                aria-label={warningMessage}
                role='img'
                data-testid='vehicle-warning-icon'
            />
        </SimpleTooltip>
    );
};

export const VehiclePlate = ({ vehicle }: VehiclePlateProps) => {
    if (!vehicle) {
        return null;
    }

    const displayValue = getVehicleDisplayName(vehicle);
    const warningState = getVehicleWarningState(vehicle);

    return (
        <span className='white-space-nowrap'>
            {displayValue}
            <VehicleWarningIcon warningState={warningState} />
        </span>
    );
};
